import React from 'react';

import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import IconButton from 'material-ui/IconButton';
import Button from 'material-ui/Button';
import Snackbar from 'material-ui/Snackbar';

import MDeliveryHeader from '../components/MDeliveryHeader';
import MDeliverySequence from '../components/MDeliverySequence';
import MonitoningDeliveries from '../components/MonitoningDeliveries';
import SynopticTime from '../components/SynopticTime';
import StateButton from '../components/StateButton';
import SyncData from '../components/SyncData';

import { CircularProgress } from 'material-ui/Progress';
import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import moment from 'moment';

const MonitoringDeliveryContainer = ({match, history, document_store}) => {
    const document_id = match.params.id;
    const document = document_store.getDocument(document_id);

    if (!document_store.is_fetched && document_store.fetching) {

        return (
            <div className="text-center" style={{marginTop: '36px'}}>
                <div><CircularProgress /></div>
                <p><small>Carregando...</small></p>
            </div>
        );
    }

    const syncData = () => {
        document_store.fetch({filter: { id: document_id }});
    }

    if (!document) {
        setTimeout(() => syncData(), 200);
        return null;
    }

    const location = document.location || {};

    const onRequestClose = e => {
        history.push('/');
    }

    const onDone = () => {
        document_store.fetch({filter: { id: document_id }});
    }

    const getLastUpdated = () => {
        const location_datetime = moment(location.datetime);
        const now = moment();

        const diff = now.diff(location_datetime, 'days');

        if (diff >= 1) {
            return 'Há mais de um dia sem receber atualização.';
        }

        return location_datetime.format('DD/MM/YYYY HH:mm:ss');
    }

    const weight_occupation = (Number.isFinite(document.weight_occupation)) ? `${document.weight_occupation}%` : 'indefinido';
    const volume_occupation = (Number.isFinite(document.volume_occupation)) ? `${document.volume_occupation}%` : 'indefinido';

    const deliveries = document_store.getDeliveriesByCustomers(document);

    return (
        <div className="container-full">
            <AppBar classes={{root: 'create-toolbar'}}>
                <Toolbar className="toolbar">
                    <IconButton onClick={onRequestClose}>
                        <i className="material-icons">close</i>
                    </IconButton>

                    <Typography type="title" color="inherit">
                        <div className="title">Documento de Entrega</div>
                    </Typography>

                    <div className="app-action-buttons">
                        <Button onClick={syncData}>
                            <i className="material-icons">sync</i>
                        </Button>

                        <StateButton onDone={onDone} document={document} />
                    </div>
                </Toolbar>
            </AppBar>

            <div className="monitoring-delivery-container">
                <MDeliveryHeader document={document} />
                <MDeliverySequence data-updated-at={document_store.updated_at} deliveries={deliveries} />
                <SynopticTime location={location} />

                <div className="md-container">
                    <h3>Informações</h3>
                    <b>ID:</b> {document.id} - <b>Peso:</b> {document.weight}Kg<br />
                    <b>Últ. atualização:</b> {getLastUpdated()}<br />
                    {/*<b>Documento criado em:</b> {moment(document.created_at).format('DD/MM/YYYY HH:mm')}*/}

                    <h4>Taxa de ocupação:</h4>
                    <b>Peso:</b> {weight_occupation}<br />
                    <b>Volume:</b> {volume_occupation}<br />
                </div>

                <MonitoningDeliveries data-updated-at={document_store.updated_at} deliveries={deliveries} />
                <SyncData />

                <Snackbar
                    anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                    open={document_store.fetching}
                    message={<span>Carregando...</span>}
                />
            </div>
        </div>
    );

}

let container = observer(MonitoringDeliveryContainer);
container = inject(['document_store'])(container);

export default withRouter(container);



// WEBPACK FOOTER //
// ./src/containers/monitoring_delivery.js